// extracted by mini-css-extract-plugin
export var createUser = "create-user_dAuQ1AXJqE454hKXDenU";
export var createUserHeader = "create-user__header_ScP6TcBxjSqFucx7bB5g";
export var createUserTitle = "create-user__title_LFdiDnBPkGWNDCFJUths";